import styled, { css } from "styled-components";

interface IAccountPageContainerProps {
  renderMenu?: boolean;
  isMobile?: boolean;
}

export const AccountPageContainer = styled.div<IAccountPageContainerProps>`
  width: 100%;
  height: 100%;
  max-width: 845px;
  margin: 6rem auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start !important;

  @media (max-width: 1100px) {
    margin: 2rem auto 0 auto;
  }

  padding: 0 1rem;

  .content {
    display: flex;
    align-items: flex-start;
    justify-content: center;

    width: 100%;
    min-width: 100%;
    height: max-content;
    row-gap: 20px;
    column-gap: 20px;

    margin: 0 0 100px;
  }

  img.arrow-icon {
    cursor: pointer;
  }

  ${({ renderMenu }) =>
    renderMenu
      ? css`
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
        `
      : css`
          display: flex;
          justify-content: center;
          align-items: center;
        `}

  h1,
      span,
      input {
    color: ${({ theme }) => theme.colors.textColor};
  }

  button {
    span {
      color: ${({ theme }) => theme.colors.btnTextColor};
    }
  }

  .header-card.card-style {
    background: ${(props) =>
      props.theme.colors.modalBackgroundColor} !important;
    display: flex;
    justify-content: center;
    align-items: center;

    h2,
    p {
      color: ${({ theme }) => theme.colors.textColor};
    }
  }

  .user-container,
  .data-container {
    background: ${(props) =>
      props.theme.colors.modalBackgroundColor} !important;

    h2,
    h3,
    p {
      color: ${({ theme }) => theme.colors.textColor} !important;
    }

    .card-address {
      background: ${(props) =>
        props.theme.colors.inputBackgroundColor} !important;
      border-color: transparent;

      h4 {
        color: ${({ theme }) => theme.colors.textColor};
      }

      svg {
        color: ${({ theme }) => theme.colors.textColor};
      }
    }

    .card-style {
      background-color: ${({ theme }) => theme.colors.inputBackgroundColor};

      input {
        background-color: ${({ theme }) => theme.colors.modalBackgroundColor};
        border: 1px solid ${({ theme }) => theme.colors.borderColor};
        color: ${({ theme }) => theme.colors.textColor};

        &:hover {
          border-color: ${({ theme }) => theme.colors.primary};
        }
      }
    }

    .interests {
      .card-style {
        background: unset !important;
      }
    }

    .card {
      .ant-radio-wrapper {
        border-color: ${({ theme }) => theme.colors.borderColor} !important;

        .ant-radio-checked .ant-radio-inner::after {
          background: ${({ theme }) => theme.colors.primary} !important;
        }
      }
    }
  }

  ${(props) =>
    props.isMobile &&
    css`
      .ant-breadcrumb {
        text-align: center;
      }

      .ant-breadcrumb + h1 {
        text-align: center;
      }

      .content {
        grid: none;
        display: flex;
        align-items: center;
        flex-direction: column;

        .header-card {
          width: 100%;
        }

        .data-container {
          width: 100%;

          .card-style {
            width: 100%;
          }
        }

        .ant-radio-wrapper {
          width: 100% !important;
        }

        > .card-style {
          width: 100%;
          height: max-content;

          h3 {
            display: none;
          }

          li {
            justify-content: center;
            border-radius: 8px !important;
            padding: 18px 0px;
          }

          ul {
            flex-wrap: wrap;
            display: flex;
            justify-content: center;
          }
        }
      }
    `}
`;
